module.exports = __webpack_public_path__ + "img/bg1.b259ed59.png";